/**
 * Sync Tools Routes
 */
import React from 'react'
import { Routes, Route } from 'react-router-dom'
import SyncToolsDashboard from './SyncToolsDashboard'
import ValidateSyncData from './ValidateSyncData'

const SyncToolsRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<SyncToolsDashboard />} />
      <Route path="validate" element={<ValidateSyncData />} />
    </Routes>
  )
}

export default SyncToolsRoutes